<template>
  <div class="flex flex-row items-center gap-3 p-3">
    <div class="bg-primary-container flex h-10 w-10 items-center justify-center rounded-full">
      <BaseIcon class="text-on-primary-container">{{ icon }}</BaseIcon>
    </div>
    <div class="flex grow flex-col">
      <div class="flex flex-row items-center gap-2">
        <h3 class="text-body-large">{{ title }}</h3>
      </div>
      <p v-if="subtitle" class="text-body-small text-on-surface-variant">{{ subtitle }}</p>
      <p class="text-body-small text-on-surface-variant">{{ url }}</p>
    </div>
    <div class="text-label-large text-on-surface-variant flex flex-row items-center">
      {{ $t('common.numberOfFeedbacks', { count: numberOfFeedbacks }) }}
    </div>
    <div class="flex flex-row items-center gap-0.5">
      <BaseIconButton
        v-tooltip="$t('common.qrCode')"
        icon="qr_code"
        size="S"
        color="standard"
        @click="() => emits('openQRCodeDialog')"
      />
      <BaseIconButton
        v-tooltip="$t('common.copy')"
        icon="content_copy"
        size="S"
        color="standard"
        @click="copyToClipboard"
      />
      <BaseIconButton
        v-if="hasWebshare"
        v-tooltip="$t('common.share')"
        icon="share"
        size="S"
        color="standard"
        @click="shareLink"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { useShareLink } from '@/core/composables/use-share-link'

  interface Props {
    url: string
    title: string
    numberOfFeedbacks: number
    icon?: string
    isPersonal?: boolean
    subtitle?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    icon: 'link',
    isPersonal: false,
  })

  const { copyToClipboard, shareLink, hasWebshare } = useShareLink(props.url)

  const emits = defineEmits<{
    (e: 'openQRCodeDialog'): void
  }>()
</script>
